import { useParams } from 'next/navigation';
import Image from 'components/gruenland/atoms/image';
import Typography from 'components/gruenland/atoms/typography';
import { CurrencyHelpers } from 'helpers/currencyHelpers';
import { productTileImage } from 'lib/wardaImages';
import { LineItem } from 'types/entity/cart';
import { useFormat } from 'helpers/hooks/useFormat';

type OrderItemProps = {
  lineItem: LineItem;
};

const OrderItem: React.FC<OrderItemProps> = ({ lineItem }) => {
  const { locale } = useParams();
  const { formatMessage } = useFormat({ name: 'gruenland' });

  return (
    <div key={lineItem.lineItemId} className="flex justify-start border-b py-4">
      <div className="relative h-[104px] w-[88px] shrink-0">
        <Image
          fill
          src={productTileImage(lineItem.variant?.images)}
          style={{ objectFit: 'contain' }}
          alt={lineItem.name}
        />
      </div>
      <div className="flex flex-col justify-center pl-4">
        <Typography className="text-primary-black">{lineItem?.name}</Typography>
        <p>
          <span className="text-xs text-neutrals-gray">
            {formatMessage({ id: 'pdp.size', defaultMessage: 'Taglia' })}: {lineItem.variant?.attributes?.size}
          </span>
        </p>
        <p>
          <span className="text-xs text-neutrals-gray">
            {formatMessage({ id: 'pdp.color', defaultMessage: 'Colore' })}:{' '}
            <Typography as="span">{lineItem.variant?.attributes?.colour}</Typography>
          </span>
        </p>
        <Typography className="mt-2 font-medium text-primary-black">
          {CurrencyHelpers.formatForCurrency(lineItem?.price as number, locale)}
        </Typography>
        <Typography className="mt-2 text-primary-black">{`x ${lineItem?.count}`}</Typography>
      </div>
    </div>
  );
};

export default OrderItem;
